import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewRef} from '@angular/core';
import {FinancialSnapshotParams, ReportsService} from '../reports.service';
import {MatTableDataSource} from '@angular/material/table';
import {DatePipe, formatDate} from '@angular/common';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {
  ReportFinancialSnapshotDetailComponent
} from './report-financial-snapshot-detail/report-financial-snapshot-detail.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DocumentDataModel} from '../../../models/document/document-data.model';
import {FileManagerService} from '../../file-manager/file-manager.service';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {EnterpriseService} from '../../../services/enterprise.service';
import {ConversionUtilities} from "../../../utilities/conversion.utilities";

export interface IParams {
  isProvider: boolean;
  isPractice: boolean;
  PracticeId: number;
  ProviderId: string;
  PracticeLocations: string[];
  ProvidersId: string[];
  initialDate: string;
  endDate: string;
  isAsc: boolean;
  showInactive: boolean;
  reportName: string;
  dateRange: string;
  CurrentLocation: string;
}

@Component({
  standalone: false,
  selector: 'app-report-financial-snapshot',
  templateUrl: './report-financial-snapshot.component.html',
  styleUrls: ['./report-financial-snapshot.component.scss']
})
export class ReportFinancialSnapshotComponent implements OnInit {
  financialSnapshotDataSource: FinancialSnapshotParams[] = [];
  displayedColumns = [];
  codeLabels = [];
  displayedDoctorColumns = [];
  dataSource: MatTableDataSource<any>;
  isLoading: boolean = false;
  isProvider: boolean;
  PracticeId: number;
  initialDate: string;
  endDate: string;
  endDateLabel: string;
  oldParams: IParams;
  reportLogoDocument: DocumentDataModel;
  selectedClient: TdoClientConfigurationModel;
  DateToday: string;
  ReportName: string;
  dateRange: string;
  ProviderPracticeName: string;
  ProviderPracticeTopAddress: string;
  ProviderPracticeBottomAddress: string;
  ProviderTDOCID: number;

  @Output() newItemEvent = new EventEmitter<any>();

  dataColumns = [
     // 'ID',
    'FullName',
    // 'Address',
    'totalProduction',
    'adjustedProduction',
    'totalContractedProduction',
    'mtd',
    'lastYearMTD',
    'ytd',
    'lastYTD',
    'debitAdjustment',
    'collections',
    'cash',
    'check',
    'creditCard',
    'visa',
    'mastercard',
    'discovery',
    'amex',
    'other_CreditCard',
    'debit_Card',
    'other',
    'totalReceipts',
    'adjustedReceipts',
    'totalInsuranceCollected',
    'mtdCollections',
    'lastYearMTDCollections',
    'ytdCollections',
    'lastYTDCollections',
    'creditAdjustmentsCollections',
    'ar029Collections',
    'ar30Collections',
    'ar60Collections',
    'ar90Collections',
    'arAllCollections',
    // Various Statistics
    'newWebReferrals',
    'newNonWebReferrals',
    'patientsSeen',
    'daysWorked',
    'casesStarted',
    'casesCompleted',
    'internalEmergencies',
    'externalEmergencies',
    'failedCanceledAppointments',
    'consultsSeen',
    'avgPICmpltdCases',
    'treatmentTime',
    'waitingTime',
    // After {End Date}
    'patientToBeSeen',
  ];
  labels = [
    ['Gross Production', '000000000000'],
    ['Total Standard Production', '000000000001'],
    ['Adjusted Production', '000000000002'],
    ['Total Contracted Production', '000000000027'],
    ['MTD', '000000000003'],
    ['Last Year MTD', '000000000004'],
    ['YTD', '000000000005'],
    ['Last YTD', '000000000006'],
    ['Debit Adjustment', '000000000007'],
    ['Collections', '000000000000'],
    ['Cash', '000000000008'],
    ['Check', '000000000009'],
    ['Credit Card', '000000000010'],
    ['  Visa', '000000000011'],
    ['  Mastercard', '000000000012'],
    ['  Discover', '000000000013'],
    ['  Amex', '000000000014'],
    ['  Other Credit Cards', '000000000031'],
    ['Debit Card', '000000000030'],
    ['Other', '000000000015'],
    ['Total Receipts', '000000000016'],
    ['Adjusted Receipts', '000000000017'],
    ['Total Insurance Collected', '000000000028'],
    ['MTD', '000000000018'],
    ['Last Year MTD', '000000000019'],
    ['YTD', '000000000020'],
    ['Last YTD', '000000000021'],
    ['Credit Adjustments', '000000000022'],
    ['AR 0-29', '000000000029'],
    ['AR 30-59', '000000000023'],
    ['AR 60-89', '000000000024'],
    ['AR 90+', '000000000025'],
    ['AR All', '000000000026'],
    // Various Statistics
    ['New Web Referrals', '000000000000'],
    ['New Non-Web Referrals', '000000000000'],
    ['Patients Seen', '000000000000'],
    ['Days Worked', '000000000000'],
    ['Cases Started', '000000000000'],
    ['Cases Completed', '000000000000'],
    ['Internal Emergencies', '000000000000'],
    ['External Emergencies', '000000000000'],
    ['Failed/Canceled Appointments', '000000000000'],
    ['Consults Seen', '000000000000'],
    ['Avg PI(Cmpltd Cases)', '000000000000'],
    ['Treatment Time', '000000000000'],
    ['Waiting Time', '000000000000'],
    ['Patient to be Seen After ' + formatDate(new Date(), 'yyyy/MM/dd', 'en'), '000000000000']
  ];
  DailyLabels = [
    ['Gross Production', '000000000000'],
    ['Total Standard Production', '000000000001'],
    ['Adjusted Production', '000000000002'],
    ['Total Contracted Production', '000000000027'],
    ['Debit Adjustment', '000000000007'],
    ['Collections', '000000000000'],
    ['Cash', '000000000008'],
    ['Check', '000000000009'],
    ['Credit Card', '000000000010'],
    ['  Visa', '000000000011'],
    ['  Mastercard', '000000000012'],
    ['  Discover', '000000000013'],
    ['  Amex', '000000000014'],
    ['  Other Credit Cards', '000000000031'],
    ['Debit Card', '000000000030'],
    ['Total Receipts', '000000000016'],
    ['Adjusted Receipts', '000000000017'],
    ['Total Insurance Collected', '000000000028'],
    ['Credit Adjustments', '000000000022'],
   ];
  DailyDataColumns = [
    'FullName',
    'totalProduction',
    'adjustedProduction',
    'totalContractedProduction',
    'debitAdjustment',
    'collections',
    'cash',
    'check',
    'creditCard',
    'visa',
    'mastercard',
    'discovery',
    'amex',
    'other_CreditCard',
    'debit_Card',
    'totalReceipts',
    'adjustedReceipts',
    'totalInsuranceCollected',
    'creditAdjustmentsCollections',
  ];

  constructor(private service: ReportsService,
              private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private fileManagerService: FileManagerService,
              private enterpriseService: EnterpriseService,
              private datePipe: DatePipe,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.DateToday = this.datePipe.transform(new Date(), 'longDate');

  }

  getSelectedClientLogo() {
    const docIds: string[] = [];
    docIds.push(this.selectedClient.LogoReport_DocumentID);
    this.fileManagerService.getDocuments(docIds).subscribe((res) => {
      this.reportLogoDocument = res.find(p => p.DocumentID === this.selectedClient.LogoReport_DocumentID);
      this.cdr.detectChanges();
    });
  }

  loadReport(parameters: IParams, isDaily: boolean) {
    this.isLoading = true;
    this.isProvider = parameters.isProvider;
    this.PracticeId = parameters.PracticeId;
    this.initialDate = parameters.initialDate;
    this.endDate =  parameters.endDate;
    this.ReportName = parameters.reportName;
    this.dateRange = parameters.dateRange;
    this.endDateLabel = this.datePipe.transform(ConversionUtilities.convertUTCDateToLocalDateFromString(parameters.endDate), 'longDate'); //ConversionUtilities.convertUTCDateToLocalDateFromString(parameters.endDate);

    // check if is needed to recall server
    const differentObject = this.differenceInObj(this.oldParams, parameters );
    // if user just changed sort
    if (Object.keys(differentObject).length === 1 && differentObject.hasOwnProperty('isAsc')  ){
      if (differentObject.isAsc === true){
        /*this.financialSnapshotDataSource.sort((a, b) =>
          ((a.DoctorID === null )a.FullName > b.FullName) ? 1 : -1);*/

        // tslint:disable-next-line:only-arrow-functions
        this.financialSnapshotDataSource.sort(function(a, b) {
          if (a.DoctorID === b.DoctorID) { return 0; }
          if (a.DoctorID === null) { return 1; }
          if (b.DoctorID === null) { return 1; }

          if (a.DoctorID < b.DoctorID) {
            return -1;
          }
          if (a.DoctorID > b.DoctorID) {
            return 1;
          }
          return 0;
        });
        }
      else{
        this.financialSnapshotDataSource.sort(function(a, b) {
          if (a.DoctorID === b.DoctorID) { return 0; }
          if (a.DoctorID === null) { return 1; }
          if (b.DoctorID === null) { return 1; }

          if (a.DoctorID < b.DoctorID) {
            return 1;
          }
          if (a.DoctorID > b.DoctorID) {
            return -1;
          }
          return 0;
        });
      }
      // load page
      this.transpose(isDaily);
      this.fillLabels();
      this.isLoading = false;
      if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      this.oldParams = parameters;
      return;
    }
    // needs to call service
    this.oldParams = parameters;
    // get report header info
    this.getHeaderInfo(parameters);
    // get client logo
    this.getClientLogo(parameters.PracticeId);
    // get report body
    this.getReportBody(parameters, isDaily);
  }

  /*convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }

    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }*/

  /*convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }*/

  getHeaderInfo(parameters){
    this.service.getFinancialSnapshotHeader(parameters)
      .subscribe(response => {

        this.ProviderPracticeName = response.FullName;
        this.ProviderPracticeTopAddress = response.AddressTop;
        this.ProviderPracticeBottomAddress = response.AddressBottom;
        this.ProviderTDOCID = response.TDOCID;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      }, error =>  {
        this.showMessage('Error', 'Error getting reports');
      });
  }
  getClientLogo(practiceId: number){
    this.enterpriseService.getClients().subscribe((data) => {
      if (data.length > 0) {
        if (this.isProvider && (this.ProviderTDOCID === 0 || this.ProviderTDOCID === undefined)) {
          // this.isLoading = false;
          return;
        }
        if (this.isProvider) {
          this.selectedClient = data.find(x => x.TDOCID === this.ProviderTDOCID);
        }
        else{
          this.selectedClient = data.find(x => x.TDOCID === practiceId);
        }
        this.getSelectedClientLogo();
        // this.isLoading = false;
      }
    }, err => {
      console.log(err);
    });
  }
  getReportBody(parameters: IParams, isDaily: boolean)
  {
    this.service.getFinancialSnapshotDataSource(parameters, isDaily)
      .subscribe(response => {
        // reports
        this.financialSnapshotDataSource = response;
        // load page
        this.transpose(isDaily);
        this.fillLabels();
        this.isLoading = false;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      }, err => {
        this.showMessage('Error', 'Error getting reports');
        this.isLoading = false;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      });
  }

  differenceInObj(firstObj: any, secondObj: any): any {
    const differenceObj: any = {};
    for (const key in firstObj) {
      if (Object.prototype.hasOwnProperty.call(firstObj, key)) {
        if (firstObj[key] !== secondObj[key]) {
          differenceObj[key] = firstObj[key];
        }

      }
    }
    return differenceObj;
  }

  getImageUrl(propertyName: string, document: DocumentDataModel) {
    return this.fileManagerService.getDocumentUrlFromDocument(document);
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  transpose(isDaily: boolean) {
    const transposedData = [];
    if (!isDaily) {
      for (let column = 0; column < this.dataColumns.length; column++) {
        transposedData[column] = {
          label: this.labels[column][0],
          labelCode: this.labels[column][1]
        };
        for (let row = 0; row < this.financialSnapshotDataSource.length; row++) {
          transposedData[column][`column${row}`] = this.financialSnapshotDataSource[row][this.dataColumns[column]];
        }
      }
    }
    else{
      for (let column = 0; column < this.DailyDataColumns.length; column++) {
        transposedData[column] = {
          label: this.DailyLabels[column][0],
          labelCode: this.DailyLabels[column][1]
        };
        for (let row = 0; row < this.financialSnapshotDataSource.length; row++) {
          transposedData[column][`column${row}`] = this.financialSnapshotDataSource[row][this.DailyDataColumns[column]];
        }
      }
    }
    this.dataSource = new MatTableDataSource(transposedData);
  }

  fillLabels() {
    this.displayedColumns = ['label'];
    this.codeLabels = ['labelCode'];
    for (let i = 0; i < this.financialSnapshotDataSource.length; i++) {
      this.displayedColumns.push('column' + i);
      this.codeLabels.push('column' + i);
    }
  }

  openDialog(row: any, cell: string, index: number){
    if (cell.includes('$') && row.labelCode !== '000000000000')
    {
      const DoctorID = this.financialSnapshotDataSource[index].DoctorID;
      const LOCID = this.financialSnapshotDataSource[index].LOCID;

      if (DoctorID !== null) { // total columns
        const config = new MatDialogConfig();
        config.width = '1500px';
        config.height = '580px';
        config.data = {
          ConceptBreakdownId: row.labelCode,
          ConceptDetail: row.label,
          DoctorId: DoctorID,
          LOCId: LOCID,
          Amount: cell,
          isProvider: this.isProvider,
          PracticeId: this.PracticeId,
          initialDate: (row.labelCode === '000000000023' || row.labelCode === '000000000024' || row.labelCode === '000000000025' || row.labelCode === '000000000026' || row.labelCode === '000000000029') ? new Date() : this.initialDate,
          endDate: (row.labelCode === '000000000023' || row.labelCode === '000000000024' || row.labelCode === '000000000025' || row.labelCode === '000000000026' || row.labelCode === '000000000029') ? new Date() : this.endDate,
        };
        config.panelClass = 'dialog';
        const reportViewer = this.dialog.open(ReportFinancialSnapshotDetailComponent, config);

      }
    }
  }

}




